import { Button, Box } from "@vapor/react-material";
import { LoginFormDto } from "../../dtos/LoginFormDto";
import Typography from "@vapor/react-extended/ExtendedTypography";

import { useGetConfig } from "@onefront/forrestjs-react-root";
import { useProxy } from "@onefront/react-sdk";

const LoginForm = (props: LoginFormDto) => {
    const { createTargetUrl } = useProxy();

    const appId = useGetConfig("one.appId", "app3000");
    const targetUrl = useGetConfig("one.login.target.url", "loginApp");
    const targetUrlParams = useGetConfig("one.login.target.params", ["mode=redirect"]);
    const loginUrl = createTargetUrl(targetUrl, [...targetUrlParams, `appId=${appId}`]);

    return (
        <Box>
            <Box>
                <img
                    src={props.logo.src}
                    alt={props.logo.description}
                />
            </Box>
            <Box
                sx={{
                    marginTop: "6rem",
                    marginBottom: "3rem",
                    display: "flex",
                    flexDirection: "column",
                    gap: "3rem",
                }}
            >
                <Box>
                    <Typography
                        variant="leadSmall"
                        color="rgb(0, 80, 117)"
                    >
                        Accedi o registrati a {props.appName}
                    </Typography>
                </Box>
                <Button
                    variant="contained"
                    sx={{ width: "100%" }}
                    onClick={() => {
                        window.location.href = loginUrl;
                    }}
                >
                    {props.loginButtonLabel}
                </Button>
            </Box>
        </Box>
    );
};

export default LoginForm;
